import { Appointment, AppointmentControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 * @author Shrinivas Mandhare
 */
export const useAddAppointment = () =>
  useMutationWithLoading(async (params: Appointment & { xTENANTID?: string }) =>
    new AppointmentControllerApi(getConfigObject()).createAppointment(
      params,
      params.xTENANTID
    )
  );
